var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        _vm.componentType,
        {
          tag: "component",
          attrs: { noCloseOnBackdrop: "", noCloseOnScape: "", hideClose: "" },
          model: {
            value: _vm.localValue,
            callback: function($$v) {
              _vm.localValue = $$v
            },
            expression: "localValue"
          }
        },
        [
          _c("paginated-table", {
            attrs: { fields: _vm.columns, items: _vm.data },
            scopedSlots: _vm._u([
              {
                key: "head()",
                fn: function(data) {
                  return [
                    data.column.includes("num")
                      ? _c(
                          "span",
                          [
                            _c("base-icon", {
                              attrs: {
                                src: _vm.getConsultationIcon(data.column),
                                color: _vm.BLUE_COLOUR
                              }
                            })
                          ],
                          1
                        )
                      : data.label
                      ? _c("span", {
                          domProps: { innerHTML: _vm._s(data.label) }
                        })
                      : _vm._e()
                  ]
                }
              },
              {
                key: "cell(action)",
                fn: function(data) {
                  return [
                    _c(
                      "base-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.$emit(
                              "servicesPackageSelected",
                              data.item.id
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("hire")))]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-5" },
            [
              _c("b-icon-info-circle"),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("minorsAndSpousesIncluded")) +
                  "\r\n        "
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c382c69", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c382c69","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ServicesPackagesTable.vue
// module id = 4132
// module chunks = 2